/**
 * Zentrale Definition der unterstützten Sprachen/Locales.
 * Einzige Quelle für Sprachcodes und Anzeige (Name, Flagge) in der App.
 */
export const DEFAULT_LOCALE = 'en';
/** Unterstützte Sprachcodes (mit unseren Übersetzungsdateien) */
export const SUPPORTED_LOCALE_CODES = [
    'de',
    'en',
    'fr',
    'es',
    'it',
    'pt',
    'nl',
    'pl',
    'cs',
    'ja',
    'ko',
    'zh',
    'ru',
    'uk',
    'no',
    'sv'
];
/** Prüft, ob ein Sprachcode unterstützt wird */
export function isSupportedLocale(code) {
    return SUPPORTED_LOCALE_CODES.includes(code);
}
/**
 * Mappt einen Browser-Locale-String (z. B. "de-DE", "en-US") auf einen
 * unterstützten Sprachcode. Nicht unterstützte Sprachen → DEFAULT_LOCALE (en).
 */
export function resolveToSupportedLocale(browserLocale) {
    const lang = browserLocale.split(/[-_]/)[0]?.toLowerCase() ?? '';
    return isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;
}
/** Liste für Sprachauswahl-UI (Code, Anzeigename, Flagge + Ländercode) */
export const LOCALE_OPTIONS = [
    { code: 'de', name: 'Deutsch', emoji: '🇩🇪', countryCode: 'DE' },
    { code: 'en', name: 'English', emoji: '🇺🇸', countryCode: 'US' },
    { code: 'fr', name: 'Français', emoji: '🇫🇷', countryCode: 'FR' },
    { code: 'es', name: 'Español', emoji: '🇪🇸', countryCode: 'ES' },
    { code: 'it', name: 'Italiano', emoji: '🇮🇹', countryCode: 'IT' },
    { code: 'pt', name: 'Português', emoji: '🇵🇹', countryCode: 'PT' },
    { code: 'nl', name: 'Nederlands', emoji: '🇳🇱', countryCode: 'NL' },
    { code: 'pl', name: 'Polski', emoji: '🇵🇱', countryCode: 'PL' },
    { code: 'cs', name: 'Čeština', emoji: '🇨🇿', countryCode: 'CZ' },
    { code: 'ja', name: '日本語', emoji: '🇯🇵', countryCode: 'JP' },
    { code: 'ko', name: '한국어', emoji: '🇰🇷', countryCode: 'KR' },
    { code: 'zh', name: '中文', emoji: '🇨🇳', countryCode: 'CN' },
    { code: 'ru', name: 'Русский', emoji: '🇷🇺', countryCode: 'RU' },
    { code: 'uk', name: 'Українська', emoji: '🇺🇦', countryCode: 'UA' },
    { code: 'no', name: 'Norsk', emoji: '🇳🇴', countryCode: 'NO' },
    { code: 'sv', name: 'Svenska', emoji: '🇸🇪', countryCode: 'SE' }
];
